<template>
  <v-app style="padding-top: 20px">
    <v-container grid-list-md>
      <h2
        class="font-weight-bold"
        style="font-size: 3.3125rem !important;
    line-height: 1.15em !important;"
      >
        Get In Touch With EverOwl
      </h2>
      <div style="border: 2px solid #768ede; max-width: 150px"></div>
      <p class="subheading mt-3 mb-5 font-weight-light">
        Let's start on your new project!
      </p>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-form ref="submitForm">
            <v-container pt-1>
              <v-layout row wrap style="padding-right: 20px">
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="name"
                    label="Name"
                    :rules="rules.nameRules"
                    hint="Ensure it is not empty."
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="company"
                    :rules="rules.companyRules"
                    hint="Ensure it is your company name."
                    label="Company"
                    clearable
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-right: 20px">
                <v-flex xs12>
                  <v-textarea
                    :rules="rules.projectDescriptionRules"
                    hint="Provide brief/detailed description of your project."
                    v-model="projectDescription"
                    float
                    label="Project Description"
                    clearable
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-right: 20px">
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="email"
                    :rules="rules.emailRules"
                    hint="We will contact you through your email."
                    float
                    label="Email"
                    clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="phoneNumber"
                    :rules="rules.phoneRules"
                    hint="Ensure it is a valid phone number."
                    label="Phone Number (Optional)"
                    clearable
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-right: 20px">
                <v-flex xs12 md6>
                  <v-select
                    v-model="budget"
                    :items="[
                      'RM 5,000 and below',
                      'RM 5,001 - RM 9,999',
                      'RM 10,000 and more',
                    ]"
                    label="Budget (Optional)"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="timeframe"
                    hint="Ensure it is a valid timeframe."
                    label="Timeframe (Optional)"
                    clearable
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-right: 20px">
                <v-flex xs12>
                  <v-textarea
                    v-model="extraNotes"
                    float
                    label="PS (Optional)"
                    hint="Anything else you would like to include?"
                    clearable
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <div style="padding-right: 20px">
                <v-btn
                  color="#768ede"
                  @click="sendFormSubmission"
                  :loading="loading"
                  :disabled="loading"
                  block
                  >Send</v-btn
                >
              </div>
            </v-container>
          </v-form>
        </v-flex>
        <v-flex xs12 md6>
          <div class="outer-box hidden-sm-and-down">
            <div class="maps-box"></div>
          </div>

          <div class="google-map" ref="googleMap"></div>
        </v-flex>
      </v-layout>
    </v-container>
    
    <!-- <v-snackbar :color="snackbarColour" bottom v-model="snackbar" dark>
      <v-icon color="white" class="mr-3">mdi-bell-plus</v-icon>
      <div>{{ snackbarText }}</div>
      <v-icon size="16" @click="snackbar = false">mdi-close-circle</v-icon>
    </v-snackbar> -->
  </v-app>
</template>

<script>
import db from "@/firebase/init";
import GoogleMapsApiLoader from "google-maps-api-loader";
import GoogleMapLoader from "../utils/GoogleMapLoader.vue";
import {
  mapSettings,
  POINT_MARKER_ICON_CONFIG,
} from "../constants/mapSettings.js";

export default {
  components: {
    GoogleMapLoader,
  },

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Everowl Technologies",
    // all titles will be injected into this template
    titleTemplate: "Contact Us - Everowl Technologies",
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Want to know more about us? Talk to us today or sent us a form of your inquires!",
      },
      {
        name: "keywords",
        content:
          "everowl contact, contact us, everowl technologies support, project quotation",
      },
    ],
  },

  async mounted() {
    this.userLat = 3.150447;
    this.userLng = 101.698098;

    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ["places"],
      apiKey: "AIzaSyD_1sTeapUGdAocBWYId28dss3D-metcic",
    });

    this.google = googleMapApi;
    this.initializeMap();
  },

  data() {
    return {
      google: null,
      map: null,
      userLat: 0,
      userLng: 0,

      googleMapsLoaded: false,
      loading: false,

      // Form Details
      name: "",
      company: "",
      projectDescription: "",
      budget: "",
      timeframe: "",
      email: "",
      phoneNumber: "",
      extraNotes: "",

      // For snackbar
      snackbar: false,
      snackbarColour: "",
      snackbarText: "",

      rules: {
        nameRules: [
          (v) => !!v || "Name is required.",
          (v) => !/^\s*$/.test(v) || "White space is not allowed",
        ],
        companyRules: [
          (v) => !!v || "Company is required.",
          (v) => !/^\s*$/.test(v) || "White space is not allowed",
        ],
        projectDescriptionRules: [
          (v) => !!v || "Project Description is required.",
          (v) => !/^\s*$/.test(v) || "White space is not allowed",
        ],
        // budgetRules: [(v) => !!v || "Budget is required."],
        // timeframeRules: [
        // (v) => !!v || "Timeframe is required.",
        // (v) => !/^\s*$/.test(v) || "White space is not allowed",
        // ],
        emailRules: [
          (v) => !!v || "Email is required",
          (v) =>
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "Please provide a valid email address",
        ],
        phoneRules: [
          // (v) => !!v || "Phone number is required.",
          (v) =>
            /^[0-9]{1}[0-9]{1,11}$/.test(v) ||
            v.length === 0 ||
            "Phone number must be valid and must not contain white space",
        ],
      },
    };
  },

  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      };
    },

    mapCenter() {
      return { lat: this.userLat, lng: this.userLng };
    },
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },

    load() {
      setTimeout(() => {
        this.googleMapsLoaded = true;
      }, 500);
    },
    clearFormData() {
      this.name = "";
      this.company = "";
      this.projectDescription = "";
      this.budget = "";
      this.timeframe = "";
      this.email = "";
      this.phoneNumber = "";
      this.extraNotes = "";
    },
    sendFormSubmission() {
      if (this.$refs.submitForm.validate()) {
        this.loading = true;
        db.collection("submissionForms")
          .add({
            name: this.name,
            company: this.company,
            projectDescription: this.projectDescription,
            budget: this.budget,
            timeframe: this.timeframe,
            email: this.email,
            phoneNumber: this.phoneNumber,
            extraNotes: this.extraNotes,
            dateSubmitted: Date.now(),
          })
          .then(() => {
            this.loading = false;
            this.snackbarColour = "success";
            this.snackbar = true;
            this.snackbarText = "Succesfully submitted";
            this.$refs.submitForm.reset();
          })
          .catch((error) => {
            this.snackbarColour = "error";
            this.snackbar = true;
            this.snackbarText = "Error: " + error;
            console.error("Error writing document: ", error);
          });
      }
    },
  },
};
</script>

<style>
.google-maps-loader {
  position: relative;
  height: 600px;
  width: 100%;
  background-image: url("/img/blur-map.jpg");
  object-fit: fill;
  /* background: -webkit-linear-gradient(
    -45deg,
    #e9168c,
    #9012fe 50%,
    #006cff 100%
  );
  background: linear-gradient(-45deg, #e9168c, #9012fe 50%, #006cff 100%); */
  z-index: 1;
  /* filter: blur(2px);
  -webkit-filter: blur(2px); */
}

:focus {
  outline: none;
}

.outer-box {
  position: relative;
  width: 100%;
  max-width: 100%;
}

.maps-box {
  z-index: 1;
  background-color: #768ede;
  /* max-width: 350px; */
  width: 40%;
  height: 500px;
  margin-top: -6%;
  margin-left: 70%;
  position: absolute;
}

.google-map {
  height: 600px;
  width: 100%;
  min-height: 100%;
  z-index: 1;
  position: relative;
}
</style>
